const URL = '  https://food-mafia-server.herokuapp.com/api/hotel/';

const findRestById = (userId) => {
    console.log("In react hotel service " + userId)
    return fetch(URL + userId)
        .then(res => res.json());
}

export default findRestById;